import {
  Button,
  CircularProgress,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import DocumentTable from "../../../components/OB/BelgeYukleme";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import { safelyParseNumber } from "../../../helpers/MoneyFormat";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import IlanReklamTuruListeAPI from "../../../apis/OB/Get/IlanReklamTuruListeAPI";
import { ilanReklamvalidationSchema } from "../../../validations/EmlakBasvuru";
import FaaliyetListeAPI from "../../../apis/OB/Get/FaaliyetListeAPI";
import IrvYerTanimlariListeAPI from "../../../apis/OB/Get/IrvYerTanimlariListeAPI";
import SponsorFirmaListeAPI from "../../../apis/OB/Get/SponsorFirmaListeAPI";
import IrvBasvuruSave from "../../../apis/OB/SaveApi/IrvBasvuruSave";
import { year } from "../../../helpers/TodayDate";
import SessionStorageService from "../../../services/StorageService";
import { useNavigate } from "react-router";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import CustomTextField from "../../../components/OB/required-text-field";
import CustomDatePicker from "../../../components/OB/required-datepicker";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import Recaptcha from "../../../components/Recaptcha";
import DysAPI from "../../../apis/DysAPI";
import { useFormConfig } from "../../../hooks/useFormConfig";
import ConfigurableField from "../../../components/OB/ConfigurableField";

const IlanReklamBasvuru = (props: any) => {
  const recaptchaRef = useRef<any>(null);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);

  const [open, setOpen] = useState(false);
  const openPopup = () => {
    setOpen(true);
  };
  const [ilanReklamTuruListe, setIlanReklamTuruListe] = useState<any[]>([]);
  const [faaliyetListe, setFaaliyetListe] = useState<any[]>([]);
  const [afisYeriList, setAfisYeriList] = useState<any[]>([]);
  const [sponsorFirmaList, setSponsorFirmaList] = useState<any[]>([]);
  const [adetM2, setAdetM2] = useState("");
  const user = SessionStorageService.getUserInfo()
  useEffect(() => {
    if (user) {
      FaaliyetListeAPI.getFaaliyetListe(undefined)
        .then((response) => {
          setFaaliyetListe(response.data);
        })
        .catch((error) => { });
      SponsorFirmaListeAPI.getSponsorFirmaListe(undefined)
        .then((response) => {
          setSponsorFirmaList(response.data);
        })
        .catch((error) => { });
    }
  }, []);
  const [documents, setDocuments] = useState<any[]>([]);
  const [docsLoaded, setDocsLoaded] = useState<boolean>(false);
  const documentTableRef = useRef<HTMLDivElement | null>(null);

  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

  // Dinamik Form Konfigurasyon Hook
  const { config, isFieldVisible, getFieldLabel, buildValidationSchema } = useFormConfig('ILAN_REKLAM_BASVURU');

  const handleUpdateDocuments = (updatedDocuments: any) => {
    setDocuments(updatedDocuments);
  };
  useEffect(() => {
    setDocsLoaded(false);

    DysAPI.obBasvuruTanimBelgeList({ rfObBasvuruTanim: 5 })
      .then((res: any) => {
        console.log("Belge listesi response:", res.data);

        const list = (res?.data ?? []).map((b: any, idx: number) => {
          const zorunlu = (b.zorunluEh)
            .toString();

          return {
            id: b.sqId,
            documentName: b.belgeAdi,
            isRequired: ["E"].includes(zorunlu),
            fileName: "",
            file: null,
          };
        });


        setDocuments(list);
      })
      .catch((err: any) => {
        console.error("Belge listesi hatası:", err);
        setDocuments((prevDocs: any[]) =>
          prevDocs.map((doc) => ({
            ...doc,
            file: null,
            fileName: "",
          }))
        );
      })
      .finally(() => {
        setDocsLoaded(true);
      });
  }, []);

  const [userControlPopup, setUserControlPopup] = useState(false);
  const navigate = useNavigate();
  const closeUserControlPopup = () => {
    setUserControlPopup(false);
    navigate(-1);
  }
  const [isLoad, setIsLoad] = useState(true);
  useEffect(() => {

    if (user == null) {

      setUserControlPopup(true);
    } else {
      setIsLoad(false);
    }

  }, []);
  const { mahalleListe, yilListe } = useContext(ConstantAPISContext);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupAciklama, setPopupAciklama] = useState("");
  const [kayitBasarili, setKayitBasarili] = useState(false);

  const closePopupSonuc = () => {
    setIsPopupVisible(false);
    setPopupAciklama("");
  };
  const closePopup = () => {
    setOpen(false);
  };
  const [selectedMahalleKodu, setSelectedMahalleKodu] = useState<number | null>(
    null
  );

  const [caddeListe, setCaddeListe] = useState<any[]>([]);
  useEffect(() => {
    if (selectedMahalleKodu) {
      CaddeSokakAPI.getCaddeSokakListe(undefined, selectedMahalleKodu)
        .then((res) => {
          setCaddeListe(res.data);
        })
        .catch(() => {
          console.log("hata");
        })
        .finally(() => { });
    } else {
      setCaddeListe([]);
    }
  }, [selectedMahalleKodu]);

  return (
    isLoad ? <>
      <div className="d-flex align-self-strech justify-content-center align-items-center"> <CircularProgress /></div>
      {userControlPopup ? (

        <AciklamaAndUserControlPopup
          open={userControlPopup}
          handleClose={closeUserControlPopup}
          isUserControlPopUp={true}
          description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
        />

      ) : null}
    </> : <Formik
      validateOnMount={true}
      validationSchema={buildValidationSchema(ilanReklamvalidationSchema)}
      initialValues={{
        basvuruTuruId: 5,
        sicilKodu: user?.sicilKodu,
        vergiYili: year,
        ilanBaslamaTarihi: null,
        ilanBitisTarihi: null,
        butceGelirId: null,
        yerKodu: null,
        mahalleKodu: null,
        caddeSokakKodu: null,
        kapiNo: "",
        altKapiNo: "",
        daireNo: "",
        altDaireNo: "",
        blokKatNo: "",
        siteApartmanAdi: "",
        pafta: "",
        ada: "",
        parsel: "",
        aracPlaka: "",
        aracSaseNo: "",
        faaliyetKodu: null,
        sponsorFirmaKodu: null,
        eni: "",
        boyu: "",
        kacYonlu: "",
        kacAdet: "",
        adetM2: "",
        aciklama: "",
      }}
      onSubmit={async (values: any, { resetForm }) => {
        const missingDocuments = documents
          .filter(doc => doc.isRequired) // zorunlu belgeler
          .filter(doc => !doc.fileName);     // henüz yüklenmemiş olanlar

        if (missingDocuments.length > 0) {
          const missingDocNames = missingDocuments.map(d => d.documentName).join(", ");
          toast.error(`Lütfen şu zorunlu belgeleri yükleyin: ${missingDocNames}`);
          documentTableRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
          return; // başvuru burada durur
        }

        // reCAPTCHA’yı tetikle
        const token = await recaptchaRef.current?.handleSubmit();
        if (!token) {
          toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
          return;
        }

        setLoadingSubmit(true);
        const transformedValues = {
          ...values,
          basvuruTuruId: safelyParseNumber(values.basvuruTuruId),
          sicilKodu: safelyParseNumber(values.sicilKodu),
          vergiYili: safelyParseNumber(values.vergiYili),
          butceGelirId: safelyParseNumber(values.butceGelirId),
          yerKodu: safelyParseNumber(values.yerKodu),
          mahalleKodu: safelyParseNumber(values.mahalleKodu),
          caddeSokakKodu: safelyParseNumber(values.caddeSokakKodu),
          kapiNo: safelyParseNumber(values.kapiNo),
          daireNo: values.daireNo != "" ? safelyParseNumber(values.daireNo) : null,
          ada: values.ada != "" ? safelyParseNumber(values.ada) : null,
          parsel: values.parsel != "" ? safelyParseNumber(values.parsel) : null,
          faaliyetKodu: safelyParseNumber(values.faaliyetKodu),
          sponsorFirmaKodu: safelyParseNumber(values.sponsorFirmaKodu),
          eni: values.eni != "" ? safelyParseNumber(values.eni) : null,
          boyu: values.boyu != "" ? safelyParseNumber(values.boyu) : null,
          kacYonlu: values.kacYonlu != "" ? safelyParseNumber(values.kacYonlu) : null,
          kacAdet: values.kacAdet != "" ? safelyParseNumber(values.kacAdet) : null,
          adetM2: values.adetM2 === "ADET" ? "A" : "M",
          ilanBaslamaTarihi: values.ilanBaslamaTarihi != null ? dayjs(values.ilanBaslamaTarihi).tz("Europe/Istanbul").format("YYYY-MM-DD") : null,
          ilanBitisTarihi: values.ilanBitisTarihi != null ? dayjs(values.ilanBitisTarihi).tz("Europe/Istanbul").format("YYYY-MM-DD") : null,
          captchaToken: token

        };
        console.log("transformedValues", transformedValues);

        IrvBasvuruSave.saveIrvBasvuruSave(transformedValues)
          .then(async (res) => {
            console.log(res);
            if (res.data.sonuc === 0) {
              let basvuruNo = res.data.basvuruNo;

              // DYS API'yi çağır 
              try {
                // Sadece dosyası olanları al
                const filesToSend = documents.filter((doc: any) => !!doc.file);

                if (filesToSend.length > 0) {
                  const formData = new FormData();

                  filesToSend.forEach((doc: any) => {
                    formData.append("files", doc.file, doc.file.name);
                    formData.append("rfObBasvuruTanimBelge", String(doc.id));
                  });

                  formData.append("basvuruTuru", String(values.basvuruTuruId || 0));
                  formData.append("basvuruId", String(basvuruNo));
                  formData.append("folderName", "AKOS");
                  formData.append("kurumId", "1");
                  formData.append("versionable", "1");

                  const response = await DysAPI.upload(formData);
                  toast.warning(response.message);
                } else {
                  // Burada return yok — sadece DYS çağrısını atlıyoruz.
                  
                }
              } catch (error: any) {
                toast.error("DYS upload hazırlama hatası:", error);
              }

              setPopupAciklama("İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " + basvuruNo);
              resetForm();
              setKayitBasarili(true);
              setDocuments((prevDocs: any[]) =>
                prevDocs.map((doc) => ({
                  ...doc,
                  file: null,
                  fileName: "",
                }))
              );
            } else {
              setPopupAciklama(res.data.sonucAciklama);
            }
          })
          .catch((err) => {
            setPopupAciklama(
              "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
            );
          })
          .finally(() => {
            setIsPopupVisible(true);
            recaptchaRef.current?.reset();
            setLoadingSubmit(false);
          });
      }}
    >
      {(formikProps) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          IrvYerTanimlariListeAPI.geIrvYerTanimlariListeListe(
            undefined,
            undefined,//formikProps.values.mahalleKodu,
            undefined,//formikProps.values.caddeSokakKodu
          )
            .then((res) => {
              setAfisYeriList(res.data);
            })
            .catch((err) => { });
        }, [formikProps.values.mahalleKodu, formikProps.values.caddeSokakKodu]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          if (formikProps.values.vergiYili != null) {
            IlanReklamTuruListeAPI.getIlanReklamTuruListeListe(
              formikProps.values.vergiYili,
              undefined
            )
              .then((res) => {
                console.log(res.data)
                setIlanReklamTuruListe(res.data);
              })
              .catch((err) => { });
          } else {
            setIlanReklamTuruListe([]);
          }
        }, [formikProps.values.vergiYili]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          if (formikProps.values.ilanReklamTuru) {
            const selectedReklamTuru = ilanReklamTuruListe.find(
              (item) => item.butceGelirId === formikProps.values.ilanReklamTuru
            );
            if (selectedReklamTuru) {
              formikProps.setFieldValue("adetM2", selectedReklamTuru.adetM2);
            }
          }
        }, [formikProps.values.ilanReklamTuru, ilanReklamTuruListe]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const showToastIfErrorsExist = () => {
          if (Object.keys(formikProps.errors).length > 0) {
            focusFirstErrorField();
            toast.error("Lütfen zorunlu alanları doldurun!");

          }
        };
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const formRefs = useRef<any>({});
        const focusFirstErrorField = () => {
          const errorKeys = Object.keys(formikProps.errors);
          if (errorKeys.length > 0) {
            const firstErrorKey = errorKeys[0];
            console.log(errorKeys[0])
            const element = document.querySelector(`[name="${firstErrorKey}"]`);
            if (element) {
              (element as HTMLElement).focus();
            }
          }
        };

        return (
          <Form onSubmit={formikProps.handleSubmit}>
            <div className="row">
              <div className="col-12 mb-3">
                <div className="d-flex justify-content-end align-self-stretch">
                  <Button
                    type="button"
                    onClick={() => {
                      formikProps.resetForm({ values: formikProps.initialValues });
                      setDocuments((prevDocs: any[]) =>
                        prevDocs.map((doc) => ({
                          ...doc,
                          file: null,
                          fileName: "",
                        }))
                      );
                    }}
                    color="secondary"
                  >
                    Temizle
                  </Button>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-3 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <div className="row">
                      <ConfigurableField fieldName="vergiYili" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          select
                          label={getFieldLabel("vergiYili", "Vergi Yılı")}
                          size="small"
                          error={
                            formikProps.errors.vergiYili &&
                              formikProps.touched.vergiYili
                              ? true
                              : false
                          }
                          value={formikProps.values.vergiYili}
                          onChange={(value) => {
                            formikProps.setFieldValue(
                              "vergiYili",
                              Number(value.target.value)
                            );
                          }}
                        >
                          {yilListe.map((option) => (
                            <MenuItem key={option.yili} value={option.yili}>
                              {option.yili}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="butceGelirId" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="butceGelirId"
                          fullWidth
                          className="mb-3"
                          size="small"
                          error={
                            formikProps.errors.butceGelirId &&
                              formikProps.touched.butceGelirId
                              ? true
                              : false
                          }
                          select
                          label={getFieldLabel("butceGelirId", "İlan Reklam Türü *")}
                          value={formikProps.values.butceGelirId}
                          onChange={(value: any) => {
                            formikProps.setFieldValue(
                              "butceGelirId",
                              Number(value.target.value)
                            )
                          }
                          }
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {ilanReklamTuruListe.map((option) => (
                            <MenuItem
                              key={option.butceGelirId}
                              value={option.butceGelirId}
                            >
                              {option.butceGelirAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="ilanBaslamaTarihi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomDatePicker
                          name="ilanBaslamaTarihi"
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              error: formikProps.errors.ilanBaslamaTarihi && formikProps.touched.ilanBaslamaTarihi ? true : false
                            }
                          }}
                          label={getFieldLabel("ilanBaslamaTarihi", "İlan Başlama Tarihi *")}
                          value={formikProps.values.ilanBaslamaTarihi}
                          onChange={(value: any) =>
                            formikProps.setFieldValue("ilanBaslamaTarihi", value)
                          }
                          className="mb-3"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="ilanBitisTarihi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomDatePicker
                          name="ilanBitisTarihi"
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              error: formikProps.errors.ilanBitisTarihi && formikProps.touched.ilanBitisTarihi ? true : false
                            }
                          }}
                          label={getFieldLabel("ilanBitisTarihi", "İlan Bitiş Tarihi *")}
                          value={formikProps.values.ilanBitisTarihi}
                          onChange={(value: any) =>
                            formikProps.setFieldValue("ilanBitisTarihi", value)
                          }
                          className="mb-3"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="yerKodu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="yerKodu"
                          fullWidth
                          className="mb-3"
                          select
                          label={getFieldLabel("yerKodu", "Afiş Yeri *")}
                          size="small"
                          error={
                            formikProps.errors.yerKodu &&
                              formikProps.touched.yerKodu
                              ? true
                              : false
                          }
                          value={formikProps.values.yerKodu}
                          onChange={(value: any) => {
                            formikProps.setFieldValue(
                              "yerKodu",
                              Number(value.target.value)
                            );
                          }}
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {afisYeriList.map((option) => (
                            <MenuItem key={option.yerKodu} value={option.yerKodu}>
                              {option.yeradi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="mahalleKodu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="mahalleKodu"
                          fullWidth
                          className="mb-3"
                          select
                          label={getFieldLabel("mahalleKodu", "Mahalle *")}
                          size="small"
                          error={
                            formikProps.errors.mahalleKodu &&
                              formikProps.touched.mahalleKodu
                              ? true
                              : false
                          }
                          value={formikProps.values.mahalleKodu}
                          onChange={(value: any) => {
                            formikProps.setFieldValue(
                              "mahalleKodu",
                              Number(value.target.value)
                            );
                            setSelectedMahalleKodu(Number(value.target.value));
                            formikProps.setFieldValue("caddeSokakKodu", null);
                          }}
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {mahalleListe.map((option) => (
                            <MenuItem key={option.mahalleKodu} value={option.mahalleKodu}>
                              {option.mahalleAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="caddeSokakKodu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="caddeSokakKodu"
                          fullWidth
                          className="mb-3"
                          size="small"
                          error={
                            formikProps.errors.caddeSokakKodu &&
                              formikProps.touched.caddeSokakKodu
                              ? true
                              : false
                          }
                          select
                          label={getFieldLabel("caddeSokakKodu", "Cadde/Sokak *")}
                          value={formikProps.values.caddeSokakKodu}
                          onChange={(value: any) =>
                            formikProps.setFieldValue(
                              "caddeSokakKodu",
                              Number(value.target.value)
                            )
                          }
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {caddeListe.map((option) => (
                            <MenuItem key={option.caddeSokakKodu} value={option.caddeSokakKodu}>
                              {option.caddeSokakAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="kapiNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          name="kapiNo"
                          fullWidth
                          className="mb-3"
                          size="small"
                          error={
                            formikProps.errors.kapiNo && formikProps.touched.kapiNo
                              ? true
                              : false
                          }
                          label={getFieldLabel("kapiNo", "Kapı No *")}
                          value={formikProps.values.kapiNo}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("kapiNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 4) : "")
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="altKapiNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-4">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("altKapiNo", "Blok No/Kat No")}
                          error={
                            formikProps.errors.altKapiNo &&
                              formikProps.touched.altKapiNo
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("altKapiNo")}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="daireNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-4">
                        <CustomTextField
                          name="daireNo"
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("daireNo", "Daire No *")}
                          error={
                            formikProps.errors.daireNo && formikProps.touched.daireNo
                              ? true
                              : false
                          }
                          value={formikProps.values.daireNo}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("daireNo", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 4) : "")
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="altDaireNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-4">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("altDaireNo", "Alt Daire No")}
                          error={
                            formikProps.errors.altDaireNo && formikProps.touched.altDaireNo
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("altDaireNo")}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <div className="row">
                      <ConfigurableField fieldName="siteApartmanAdi" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-12">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("siteApartmanAdi", "Site/Apatman Adı")}
                          {...formikProps.getFieldProps("siteApartmanAdi")}
                          error={
                            formikProps.errors.siteApartmanAdi &&
                              formikProps.touched.siteApartmanAdi
                              ? true
                              : false
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="blokKatNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("blokKatNo", "Blok/Kat Adı")}
                          {...formikProps.getFieldProps("blokKatNo")}
                          error={
                            formikProps.errors.blokKatNo &&
                              formikProps.touched.blokKatNo
                              ? true
                              : false
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="pafta" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("pafta", "Pafta")}
                          {...formikProps.getFieldProps("pafta")}
                          error={
                            formikProps.errors.pafta && formikProps.touched.pafta
                              ? true
                              : false
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="ada" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("ada", "Ada")}
                          value={formikProps.values.ada}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("ada", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 10) : "")
                          }
                          error={
                            formikProps.errors.ada && formikProps.touched.ada
                              ? true
                              : false
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="parsel" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <TextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("parsel", "Parsel")}
                          onChange={(e: any) =>
                            formikProps.setFieldValue("parsel", e.target.value.match(/^[0-9]+$/) ? e.target.value.substring(0, 10) : "")
                          }
                          error={
                            formikProps.errors.parsel && formikProps.touched.parsel
                              ? true
                              : false
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="aracPlaka" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("aracPlaka", "Araç Plakası *")}
                          error={
                            formikProps.errors.aracPlaka && formikProps.touched.aracPlaka
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("aracPlaka")}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="aracSaseNo" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          fullWidth
                          className="mb-3"
                          size="small"
                          label={getFieldLabel("aracSaseNo", "Araç Şase No *")}
                          error={
                            formikProps.errors.aracSaseNo && formikProps.touched.aracSaseNo
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("aracSaseNo")}
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                    <div className="row">
                      <ConfigurableField fieldName="sponsorFirmaKodu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          fullWidth
                          className="mb-3"
                          select
                          error={
                            formikProps.errors.sponsorFirmaKodu &&
                              formikProps.touched.sponsorFirmaKodu
                              ? true
                              : false
                          }
                          label={getFieldLabel("sponsorFirmaKodu", "Sponsor Firma *")}
                          {...formikProps.getFieldProps("sponsorFirmaKodu")}
                          size="small"
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {sponsorFirmaList.map((item, number) => (
                            <MenuItem key={number} value={item.sponsorFirmaKodu}>
                              {item.sponsorFirmaAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="faaliyetKodu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-lg-6">
                        <CustomTextField
                          fullWidth
                          className="mb-3"
                          select
                          error={
                            formikProps.errors.faaliyetKodu &&
                              formikProps.touched.faaliyetKodu
                              ? true
                              : false
                          }
                          label={getFieldLabel("faaliyetKodu", "Faaliyet Adı *")}
                          {...formikProps.getFieldProps("faaliyetKodu")}
                          size="small"
                        >
                          <MenuItem selected value={null as any}>
                            {"Seçiniz.."}
                          </MenuItem>
                          {faaliyetListe.map((item, number) => (
                            <MenuItem key={number} value={item.faaliyetKodu}>
                              {item.faaliyetAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      </ConfigurableField>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mt-sm-2 mt-xxl-0 mb-lg-0">
                <div className="card shadow-none border w-100">
                  <div className="card-body">
                    <div className="row">

                      <ConfigurableField fieldName="adetM2" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth

                          size="small"
                          label={getFieldLabel("adetM2", "Adet M2")}
                          disabled={true}

                          value={formikProps.values.adetM2}

                          error={
                            formikProps.errors.adetM2 && formikProps.touched.adetM2
                              ? true
                              : false
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="kacAdet" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          size="small"
                          disabled={adetM2 === "METREKARE"}
                          label={getFieldLabel("kacAdet", "Kaç Adet")}
                          {...formikProps.getFieldProps("kacAdet")}
                          error={
                            formikProps.errors.kacAdet && formikProps.touched.kacAdet
                              ? true
                              : false
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="eni" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-md-4 mb-3">
                        <TextField
                          fullWidth
                          size="small"
                          label={getFieldLabel("eni", "Eni")}
                          disabled={adetM2 === "ADET"}
                          {...formikProps.getFieldProps("eni")}
                          error={
                            formikProps.errors.eni && formikProps.touched.eni
                              ? true
                              : false
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="boyu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-md-4 mb-3">
                        <TextField
                          fullWidth
                          size="small"
                          label={getFieldLabel("boyu", "Boyu")}
                          disabled={adetM2 === "ADET"}
                          {...formikProps.getFieldProps("boyu")}
                          error={
                            formikProps.errors.boyu && formikProps.touched.boyu
                              ? true
                              : false
                          }
                          variant="outlined"
                        />
                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="kacYonlu" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-md-4 mb-3">
                        <TextField
                          fullWidth
                          size="small"
                          label={getFieldLabel("kacYonlu", "Kaç Yönlü")}
                          disabled={adetM2 === "ADET"}

                          {...formikProps.getFieldProps("kacYonlu")}
                          error={
                            formikProps.errors.kacYonlu && formikProps.touched.kacYonlu
                              ? true
                              : false
                          }
                          variant="outlined"
                        />

                      </div>
                      </ConfigurableField>
                      <ConfigurableField fieldName="aciklama" formValues={formikProps.values} isFieldVisible={isFieldVisible}>
                      <div className="col-12 pe-0">
                        <TextField
                          id="outlined-multiline-flexible"
                          label={getFieldLabel("aciklama", "Açıklama")}
                          error={
                            formikProps.errors.aciklama && formikProps.touched.aciklama
                              ? true
                              : false
                          }
                          {...formikProps.getFieldProps("aciklama")}
                          rows={4.46}
                          fullWidth
                          multiline
                          maxRows={10}
                        />
                      </div>
                      </ConfigurableField>
                    </div>
                  </div>
                </div>
              </div>
              <div ref={documentTableRef}>
                {!docsLoaded ? (
                  <div className="d-flex justify-content-center my-2"><CircularProgress size={24} /></div>
                ) : (
                  <DocumentTable rows={documents} onUpdateDocuments={handleUpdateDocuments} />
                )}
              </div>
              <div className="col-12 mt-3">
                <div className="d-flex justify-content-end align-self-stretch">
                  <Recaptcha
                    ref={recaptchaRef}
                    changeHandleRecaptcha={setRecaptchaPassed}
                  />
                  <Button
                    onClick={() => showToastIfErrorsExist()}
                    type="submit"
                  >
                    Gönder
                  </Button>
                  {loadingSubmit && (
                    <div
                      style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(255,255,255,0.6)",
                        zIndex: 1300,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  )}
                </div>
              </div>
              {isPopupVisible ? (
                <BilgilendirmePopup
                  basvuruTuruId={formikProps.values.basvuruTuruId}
                  isSorunBildirPopup={!kayitBasarili}
                  closePopup={closePopupSonuc}
                  open={isPopupVisible}
                  editDescription={popupAciklama}
                />
              ) : null}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default IlanReklamBasvuru;
